/**
 * Excel.run wrapper with error handling
 */

import { logger } from "../shared/logger";

/**
 * Run Excel operations with error handling
 * @param callback Function that receives Excel.RequestContext
 */
export async function runExcel<T>(
  callback: (context: Excel.RequestContext) => Promise<T>
): Promise<T> {
  try {
    return await Excel.run(async (context: Excel.RequestContext) => {
      return await callback(context);
    });
  } catch (error) {
    logger.error("Excel", "runExcel failed", error);
    throw error;
  }
}
